module.exports = {
  "country": "DK",
  "artist": "Chanée & Tomas N'evergreen",
  "song": "In a Moment Like This",
  "year": "2010",
  "place": "4",
  "spotify": "0MWW8RAML03zc4gjZqcxmL"
};